import useAppView from 'Core/Hooks/useAppView'
import { SearchInput } from 'V2Components'
import { TabGroup, Typography } from 'procyon-ui'
import React, { useState } from 'react'
import { ApprovedTab, AutoApproveTab, HistoryTab, PendingTab } from './Components/Tabs'

function ApprovalList() {
  const [searchKey, setSearchKey] = useState('')

  const { appView } = useAppView()
  const getTabs = () => {
    const tabs = [
      {
        label: 'Pending',
        tabContent: (
          <div className='mt-4'>
            <PendingTab searchKey={searchKey} />
          </div>
        )
      },
      {
        label: 'Approved',
        tabContent: (
          <div className='mt-4'>
            <ApprovedTab searchKey={searchKey} />
          </div>
        )
      },
      {
        label: 'History',
        tabContent: (
          <div className='mt-4'>
            <HistoryTab searchKey={searchKey} />
          </div>
        )
      }
    ]

    return tabs
  }

  return (
    <div>
      <div className='flex justify-between items-center'>
        <Typography className='!font-bold' variant='h3'>
          Access Request Approvals
        </Typography>
        <SearchInput searchKey={searchKey} sx={{ width: '280px' }} onChange={setSearchKey} />
      </div>
      <div className='mt-4 p-4 bg-[var(--color-common-bg-base)]'>
        <TabGroup tabs={getTabs()} />
      </div>
    </div>
  )
}

export { ApprovalList }
